<template>
  <div class="main-body">
    <div class="header">结算统计</div>
    <div class="out">

      <div class="search2">

        <div style="float: right">

          <el-select size="mini" v-model="businessCode" :clearable="true"
                     placeholder="请选择商家" style="margin-right:5px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.businessName"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table" border>

        <el-table-column prop="businessName" label="商家" width="200" fixed></el-table-column>


        <el-table-column prop="orderCount" label="总订单数" width="130"></el-table-column>
        <el-table-column prop="orderMoney" label="总金额" width="130"></el-table-column>

        <el-table-column prop="startTime" :formatter="timefilter" width="100" label="开始时间"></el-table-column>
        <el-table-column prop="endTime" :formatter="timefilter" width="100" label="结束时间"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" width="100" label="生成时间"></el-table-column>


        <el-table-column label="结算状态" >
          <template slot-scope="scope">
            <div v-if="scope.row.isSettlement ==0 ">待结算</div>
            <div v-if="scope.row.isSettlement ==1 ">已结算</div>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handlePrint(scope.$index, scope.row)">打印</el-button>

            <el-button v-if="scope.row.isSettlement==0" type="text" size="mini" @click="willSettlement(scope.row)">结算</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <el-dialog title='结算凭证' :visible.sync="voucherDialog"
               :modal-append-to-body='false'
               width='800px' center top='10vh'
               :close-on-click-modal='false' @close='closeDialog'>

      <div id="printTest2" v-if="successInfo!=null">
        <div style="padding: 20px;">
          <div style="text-align: center;font-size: 25px;">
            <div>结算收据</div>
          </div>
          <div style="padding: 10px 0px;">
            <div style="float: left;">结算单位：{{govName}}</div>
            <div style="float: right;">生成日期：{{formatterTime2(successInfo.createTime).substring(0,16)}}</div>
            <div style="clear:both;"></div>
          </div>
          <div>
            <table style="width: 100%;height:200px;border: 1px solid #ddd;padding: 0px;border-collapse:collapse;">
              <tr style="height: 50px;">
                <th style="width: 20%">商家</th>
                <th style="width: 20%">总订单数</th>
                <th style="width: 20%">总金额</th>
                <th style="width: 20%">开始时间</th>
                <th style="width: 20%">结束时间</th>
              </tr>
              <tr align="center" style="height: 50px;">
                <td>{{successInfo.businessName}}</td>
                <td>{{successInfo.orderCount}}</td>
                <td>{{successInfo.orderMoney}}</td>
                <td>{{successInfo.startTime}}</td>
                <td>{{successInfo.endTime}}</td>
              </tr>
              <tr style="height: 50px">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr style="height: 50px">
                <td align="right">大写金额：</td>
                <td colspan="2">{{convertCurrency(successInfo.orderMoney)}}</td>
                <td></td>
              </tr>
            </table>

          </div>
          <div style="padding: 10px 0px;">
            <div style="float: left;">结算单位（盖章）：</div>
            <div style="float: right;">收款人：_____________</div>
            <div style="clear:both;"></div>
          </div>

        </div>
      </div>

      <div style="text-align: center">
        <el-button type="info" v-print="'#printTest2'">打印</el-button>
      </div>

    </el-dialog>



  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode, getStaffDTO} from "@/utils/auth";

export default {
  name: "Page",
  data() {
    return {

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: this.$store.state.tableHeight,

      arr_business:[],
      businessCode:'',


      voucherDialog:false,
      successInfo:null,
      govName:getStaffDTO().governmentDTO.name,

    }
  },
  components: {

  },
  created() {
    this.init();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {

      this.getBusiness();
      this.getList();
    },

    getBusiness(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.arr_business = response.data.data;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },





    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue).substring(0,10)
      }
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this

      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),

        pageIndex:this.currentPage,
        pageSize:this.pageSize,

        businessCode:this.businessCode,

      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Total/PageByGovBusinessCode",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },

    willSettlement(row){

      this.$confirm('确认已结算?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "Total/UpdateSettlement",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            totalBusinessOrderCode:row.totalBusinessOrderCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '设置成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {

      });


    },




    viewPrint(e){
      this.$nextTick(()=>{
        this.voucherDialog = true;
        this.successInfo = e;
      });
    },
    closeDialog(){
      this.getList();
    },

    handlePrint(index,row){

      let e = {businessName:row.businessName,startTime:row.startTime,endTime:row.endTime,
        orderCount:row.orderCount, orderMoney:row.orderMoney,
        createTime:row.createTime};

      this.voucherDialog = true;
      this.successInfo = e;
    },

    convertCurrency(money) {
      //汉字的数字
      var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
      //基本单位
      var cnIntRadice = new Array('', '拾', '佰', '仟');
      //对应整数部分扩展单位
      var cnIntUnits = new Array('', '万', '亿', '兆');
      //对应小数部分单位
      var cnDecUnits = new Array('角', '分', '毫', '厘');
      //整数金额时后面跟的字符
      var cnInteger = '整';
      //整型完以后的单位
      var cnIntLast = '元';
      //最大处理的数字
      var maxNum = 999999999999999.9999;
      //金额整数部分
      var integerNum;
      //金额小数部分
      var decimalNum;
      //输出的中文金额字符串
      var chineseStr = '';
      //分离金额后用的数组，预定义
      var parts;
      // 传入的参数为空情况
      if(money == '') {
        return '';
      }
      money = parseFloat(money)
      if(money >= maxNum){
        return ''
      }
      // 传入的参数为0情况
      if(money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr
      }
      // 转为字符串
      money = money.toString();
      // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
      if(money.indexOf('.') == -1){
        integerNum = money;
        decimalNum = ''
      }else{
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0,4);
      }
      //转换整数部分
      if(parseInt(integerNum,10) > 0){
        let zeroCount  = 0;
        let IntLen = integerNum.length
        for(let i = 0; i < IntLen; i++){
          let n = integerNum.substr(i,1);
          let p = IntLen - i - 1;
          let q = p / 4;
          let m = p % 4;
          if( n == '0'){
            zeroCount ++ ;
          }else{
            if(zeroCount > 0){
              chineseStr += cnNums[0]
            }
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if(m == 0 && zeroCount < 4){
            chineseStr += cnIntUnits[q];
          }
        }
        // 最后+ 元
        chineseStr += cnIntLast;
      }
      // 转换小数部分
      if(decimalNum != ''){
        let decLen = decimalNum.length;
        for(let i = 0; i <decLen; i++){
          let n = decimalNum.substr(i,1);
          if(n != '0'){
            chineseStr += cnNums[Number(n)] + cnDecUnits[i]
          }
        }
      }
      if(chineseStr == ''){
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      }else if(decimalNum == ''){
        chineseStr += cnInteger;
      }

      return chineseStr
    },

    formatterTime2(cellValue) {
      return timefilters(cellValue)
    },


  }
}
</script>


<style>
#printTest2 table tr th{
  border: 1px solid #ddd;padding: 0px;margin: 0px;
}
#printTest2 table tr td{
  border: 1px solid #ddd;padding: 0px;margin: 0px;
}
</style>
<style lang="scss" scoped>


</style>
